// import { useState } from "react";

// export default function ContactUsPage() {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     subject: "",
//     message: "",
//   });
//   const [submitted, setSubmitted] = useState(false);

//   const handleChange = (e) =>
//     setFormData({ ...formData, [e.target.name]: e.target.value });

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setSubmitted(true);
//     setFormData({ name: "", email: "", subject: "", message: "" });
//     setTimeout(() => setSubmitted(false), 4000);
//   };

//   const styles = {
//     page: {
//       background: "#f5f6fa",
//       minHeight: "100vh",
//       fontFamily: "Inter, sans-serif",
//     },

//     // ✅ Hero Banner — your exact specs
//     heroBanner: {
//       background:
//         "linear-gradient(135deg, #2563eb 0%, #1d4ed8 60%, #3b82f6 100%)",
//       width: "100%",
//     },
//     heroInner: {
//       position: "relative", // ✅ position: relative
//       maxWidth: "1440px", // ✅ max-width: 1440px
//       margin: "0 auto", // ✅ margin: 0 auto
//       padding: "68px 32px", // ✅ padding: 68px 32px (NOT crossed out)
//       color: "#ffffff", // ✅ color: #ffffff
//     },
//     heroTitle: { fontSize: "2rem", fontWeight: 700, marginBottom: 6 },
//     heroSub: { fontSize: "14px", color: "rgba(255,255,255,0.7)" },

//     body: { padding: "40px 32px", maxWidth: "1440px", margin: "0 auto" },

//     card: {
//       background: "#fff",
//       borderRadius: "10px",
//       border: "1px solid #e5e7eb",
//       overflow: "hidden",
//       display: "grid",
//       gridTemplateColumns: "1fr 1.5fr",
//     },

//     // Info Panel
//     infoPanel: {
//       background: "#2563eb",
//       padding: "2.5rem 2rem",
//       display: "flex",
//       flexDirection: "column",
//       gap: "2rem",
//     },
//     infoTitle: {
//       fontSize: "1.2rem",
//       fontWeight: 600,
//       color: "#fff",
//       marginBottom: 4,
//     },
//     infoSub: {
//       fontSize: "13px",
//       color: "rgba(255,255,255,0.75)",
//       lineHeight: 1.6,
//     },
//     infoItem: {
//       display: "flex",
//       alignItems: "flex-start",
//       gap: 12,
//       marginBottom: 16,
//     },
//     infoIconBox: {
//       width: 36,
//       height: 36,
//       borderRadius: 8,
//       background: "rgba(255,255,255,0.15)",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       flexShrink: 0,
//     },
//     infoLabel: {
//       fontSize: 11,
//       color: "rgba(255,255,255,0.55)",
//       textTransform: "uppercase",
//       letterSpacing: ".06em",
//       marginBottom: 2,
//     },
//     infoVal: { fontSize: 13, color: "#fff" },

//     // Form Panel
//     formPanel: { padding: "2.5rem 2rem" },
//     formTitle: {
//       fontSize: "1.1rem",
//       fontWeight: 600,
//       color: "#111827",
//       marginBottom: 4,
//     },
//     formSub: { fontSize: 13, color: "#6b7280", marginBottom: "1.8rem" },
//     fieldRow: {
//       display: "grid",
//       gridTemplateColumns: "1fr 1fr",
//       gap: 14,
//       marginBottom: 14,
//     },
//     field: {
//       display: "flex",
//       flexDirection: "column",
//       gap: 5,
//       marginBottom: 14,
//     },
//     label: { fontSize: 12, fontWeight: 500, color: "#374151" },

//     // ✅ Input background explicitly white — not black
//     input: {
//       padding: "9px 12px",
//       border: "1px solid #d1d5db",
//       borderRadius: 6,
//       fontSize: 13,
//       color: "#111827",
//       background: "#ffffff", // ✅ explicitly white
//       outline: "none",
//     },
//     textarea: {
//       padding: "9px 12px",
//       border: "1px solid #d1d5db",
//       borderRadius: 6,
//       fontSize: 13,
//       color: "#111827",
//       background: "#ffffff", // ✅ explicitly white
//       outline: "none",
//       resize: "none",
//       lineHeight: 1.6,
//     },
//     button: {
//       width: "100%",
//       padding: "11px",
//       background: "#2563eb",
//       color: "#fff",
//       border: "none",
//       borderRadius: 6,
//       fontSize: 14,
//       fontWeight: 500,
//       cursor: "pointer",
//       marginTop: 4,
//     },
//     success: {
//       marginTop: 12,
//       padding: "10px 14px",
//       background: "#ecfdf5",
//       border: "1px solid #6ee7b7",
//       borderRadius: 6,
//       color: "#065f46",
//       fontSize: 13,
//       textAlign: "center",
//     },
//   };

//   const contactItems = [
//     {
//       label: "Address",
//       val: "123 Business Street, Hyderabad, Telangana – 500001",
//     },
//     { label: "Phone", val: "+91 98765 43210" },
//     { label: "Email", val: "support@yourcompany.com" },
//   ];

//   return (
//     <div style={styles.page}>
//       {/* ✅ Hero Banner */}
//       {/* <div style={styles.heroBanner}>
//         <div style={styles.heroInner}>
//           <h1 style={styles.heroTitle}>Contact Us</h1>
//           <p style={styles.heroSub}>contact</p>
//         </div>
//       </div> */}

//       {/* Body */}
//       {/* <div style={styles.body}> */}
//       {/* <div style={styles.card}> */}
//       <div style={{}}>
//         <div style={styles.card}>
//           {/* Info Panel */}
//           <div style={styles.infoPanel}>
//             <div>
//               <h2 style={styles.infoTitle}>Get in Touch</h2>
//               <p style={styles.infoSub}>
//                 We're here to help and answer any question you might have.
//               </p>
//             </div>
//             <div>
//               {contactItems.map(({ label, val }) => (
//                 <div key={label} style={styles.infoItem}>
//                   <div style={styles.infoIconBox} />
//                   <div>
//                     <div style={styles.infoLabel}>{label}</div>
//                     <div style={styles.infoVal}>{val}</div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Form Panel */}
//           <div style={styles.formPanel}>
//             <h2 style={styles.formTitle}>Send a Message</h2>
//             <p style={styles.formSub}>
//               Fill out the form and we'll get back to you shortly.
//             </p>

//             <form onSubmit={handleSubmit}>
//               <div style={styles.fieldRow}>
//                 <div style={styles.field}>
//                   <label style={styles.label}>Full Name</label>
//                   <input
//                     style={styles.input}
//                     type="text"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>
//                 <div style={styles.field}>
//                   <label style={styles.label}>Email Address</label>
//                   <input
//                     style={styles.input}
//                     type="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>
//               </div>

//               <div style={styles.field}>
//                 <label style={styles.label}>Subject</label>
//                 <input
//                   style={styles.input}
//                   type="text"
//                   name="subject"
//                   value={formData.subject}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div style={styles.field}>
//                 <label style={styles.label}>Message</label>
//                 <textarea
//                   style={styles.textarea}
//                   name="message"
//                   rows="5"
//                   value={formData.message}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               <button style={styles.button} type="submit">
//                 Send Message
//               </button>

//               {submitted && (
//                 <div style={styles.success}>
//                   Your message has been sent successfully!
//                 </div>
//               )}
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import { useState } from "react";

export default function ContactUsPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setFormData({ name: "", email: "", mobile: "", message: "" });
    setTimeout(() => setSubmitted(false), 4000);
  };

  const styles = {
    outer: {
      //   position: "absolute",
      //   inset: "0",
      background: "#fcf7f7f4",
      // "linear-gradient(120deg, #1e3a8a 0%, #1d4ed8 55%, #2563eb 100%)",
      //   background:
      //     "linear-gradient(135deg, #5b6abf 0%, #7b5ea7 50%, #9b59b6 100%)",
      //   padding: "60px 32px",
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "'Inter', sans-serif",
    },
    container: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "32px",
      maxWidth: "900px",
      width: "100%",
    },
    card: {
      background: "#fff",
      borderRadius: "16px",
      padding: "2.2rem 2rem",
    },
    cardTitle: {
      fontSize: "1.2rem",
      fontWeight: 600,
      color: "#1a1a2e",
      marginBottom: "1.8rem",
    },
    infoItem: {
      display: "flex",
      alignItems: "flex-start",
      gap: 16,
      padding: 16,
      background: "#f8f9ff",
      borderRadius: 12,
      marginBottom: 14,
      border: "1px solid #ececf8",
    },
    infoIcon: {
      width: 44,
      height: 44,
      borderRadius: "50%",
      //   background: "linear-gradient(135deg, #6b74d6, #8b5ea8)",
      background: "rgb(32,85,223)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    },
    infoLabel: {
      fontSize: 14,
      fontWeight: 600,
      color: "#1a1a2e",
      marginBottom: 3,
    },
    infoVal: { fontSize: 13, color: "#6b7280", lineHeight: 1.5 },
    field: { display: "flex", flexDirection: "column", marginBottom: 16 },
    fieldLabel: {
      fontSize: 13,
      fontWeight: 500,
      color: "#1a1a2e",
      marginBottom: 6,
      display: "flex",
      alignItems: "center",
      gap: 4,
    },
    required: { color: "#e53e3e", fontSize: 13 },
    inputWrap: {
      border: "1.5px solid #e2e8f0",
      borderRadius: 8,
      overflow: "hidden",
      background: "#fff",
    },
    inputIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "8px 10px",
      background: "#f1f3ff",
      borderBottom: "1px solid #e2e8f0",
    },
    input: {
      width: "100%",
      padding: "10px 12px",
      border: "none",
      outline: "none",
      fontSize: 13,
      color: "#374151",
      background: "#ffffff",
      fontFamily: "'Inter', sans-serif",
    },
    textarea: {
      width: "100%",
      padding: "10px 12px",
      border: "none",
      outline: "none",
      fontSize: 13,
      color: "#374151",
      background: "#ffffff",
      fontFamily: "'Inter', sans-serif",
      resize: "none",
      lineHeight: 1.6,
    },
    sendBtn: {
      width: "100%",
      padding: 14,
      //   background: "linear-gradient(135deg, #6b74d6, #8b5ea8)",
      background: "rgb(32,85,223)",
      color: "#fff",
      border: "none",
      borderRadius: 10,
      fontSize: 14,
      fontWeight: 600,
      fontFamily: "'Inter', sans-serif",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      marginTop: 4,
    },
    success: {
      marginTop: 12,
      padding: "10px 14px",
      background: "#ecfdf5",
      border: "1px solid #6ee7b7",
      borderRadius: 8,
      color: "#065f46",
      fontSize: 13,
      textAlign: "center",
    },
  };

  const InfoIcon = ({ children }) => (
    <div style={styles.infoIcon}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#fff"
        strokeWidth="1.8"
      >
        {children}
      </svg>
    </div>
  );

  const InputIcon = ({ children }) => (
    <div style={styles.inputIcon}>
      <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#6b74d6"
        strokeWidth="1.8"
      >
        {children}
      </svg>
    </div>
  );

  return (
    <div style={styles.outer}>
      <div style={styles.container}>
        {/* Contact Info Card */}
        <div style={styles.card}>
          <p style={styles.cardTitle}>Contact Information</p>

          {[
            {
              icon: (
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.68A2 2 0 012 .18h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7a2 2 0 011.72 2.03z" />
              ),
              label: "Phone",
              val: "+91 9289440047",
            },
            {
              icon: (
                <>
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </>
              ),
              label: "Email",
              val: "info@mydocmaster.in",
            },
            {
              icon: (
                <>
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </>
              ),
              label: "Business Hours",
              val: "Mon - Sat : 9:00 AM – 6:00 PM",
            },
            {
              icon: (
                <>
                  <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z" />
                  <circle cx="12" cy="10" r="3" />
                </>
              ),
              label: "Address",
              val: "DocMaster\nA 75 Sector 63 Noida - 201301\nUttar Pradesh, India",
            },
          ].map(({ icon, label, val }) => (
            <div key={label} style={styles.infoItem}>
              <InfoIcon>{icon}</InfoIcon>
              <div>
                <p style={styles.infoLabel}>{label}</p>
                <p style={styles.infoVal}>
                  {val.split("\n").map((line, i) => (
                    <span key={i}>
                      {line}
                      <br />
                    </span>
                  ))}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Form Card */}
        <div style={styles.card}>
          <p style={styles.cardTitle}>Send us a Message</p>

          <form onSubmit={handleSubmit}>
            {/* Name */}
            <div style={styles.field}>
              <div style={styles.fieldLabel}>
                Name <span style={styles.required}>*</span>
              </div>
              <div style={styles.inputWrap}>
                <InputIcon>
                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </InputIcon>
                <input
                  style={styles.input}
                  type="text"
                  name="name"
                  placeholder="Enter your full name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* Email */}
            <div style={styles.field}>
              <div style={styles.fieldLabel}>
                Email <span style={styles.required}>*</span>
              </div>
              <div style={styles.inputWrap}>
                <InputIcon>
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </InputIcon>
                <input
                  style={styles.input}
                  type="email"
                  name="email"
                  placeholder="your@email.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* Mobile */}
            <div style={styles.field}>
              <div style={styles.fieldLabel}>
                Mobile <span style={styles.required}>*</span>
              </div>
              <div style={styles.inputWrap}>
                <InputIcon>
                  <rect x="5" y="2" width="14" height="20" rx="2" />
                  <line x1="12" y1="18" x2="12.01" y2="18" />
                </InputIcon>
                <input
                  style={styles.input}
                  type="tel"
                  name="mobile"
                  placeholder="+91 XXXXX XXXXX"
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* Message */}
            <div style={styles.field}>
              <div style={styles.fieldLabel}>
                Message <span style={styles.required}>*</span>
              </div>
              <div style={styles.inputWrap}>
                <textarea
                  style={styles.textarea}
                  name="message"
                  rows="4"
                  placeholder="Tell us how we can help you..."
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <button style={styles.sendBtn} type="submit">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#fff"
                strokeWidth="2"
              >
                <line x1="22" y1="2" x2="11" y2="13" />
                <polygon points="22 2 15 22 11 13 2 9 22 2" />
              </svg>
              Send Message
            </button>

            {submitted && (
              <div style={styles.success}>
                Message sent! We'll get back to you soon.
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}
